import { useContext } from "react";

/**
 * Gets the application context (aka app metadata) of the current app.
 *
 * Use this when you want to know things like locale, user settings, etc.
 */
export function useAppContext() {
    const AppContext = window.SoftrPageRenderer?.AppContext;
    if (!AppContext) {
        throw new Error("Cannot find SoftrPageRenderer on the page, is the page configured correctly?");
    }

    const ctx = useContext(AppContext);
    if (!ctx) {
        throw new Error("Cannot call useAppContext outside of AppContextProvider");
    }
    return ctx;
}
